import MoveModal from "./common/move-modal";
import { PropTypes } from "base/react-libs";
import { useIdentity } from "base/identity-resolver";
import { JourneysContext } from "apps/journeys/context/journeys-context";
import { moveConstituentToJourney } from "apps/journeys/utils/api-requests/modal-actions";
import { useTasksNotificationContext } from "apps/tasks/hooks/tasks-notification-context.js";
import { useState, useContext, useEffect } from "react";
import { trackJourneysAction } from "apps/journeys/utils/helpers";

const MoveToJourneyModal = ({ isOpen, onClose, contact, title = "Move Constituent" }) => {
  const { getAndSetGlobalTasksDueCount } = useTasksNotificationContext();
  const [journeyOptions, setJourneyOptions] = useState([]);
  const { journeys, selectedJourney, setSelectedTask, refetchJourneySteps, refetchJourneys } =
    useContext(JourneysContext);
  const { user, org } = useIdentity();

  useEffect(() => {
    const journeyOptions = journeys
      .filter((j) => j.name !== selectedJourney.name)
      .map((j) => ({ label: j.name, value: j.id }));

    setJourneyOptions(journeyOptions);
  }, [journeys, selectedJourney.name]);

  const handleSubmit = async (selectedNewJourney) => {
    trackJourneysAction("move_cadence");
    await moveConstituentToJourney(
      selectedJourney.id,
      contact.id,
      user.id,
      org.id,
      selectedNewJourney.value,
      selectedNewJourney.label
    );
    await refetchJourneySteps();
    await refetchJourneys();
    getAndSetGlobalTasksDueCount();
    onClose();
    setSelectedTask(null);
  };

  return (
    <MoveModal
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      handleSubmit={handleSubmit}
      contact={contact}
      options={journeyOptions}
      current={selectedJourney}
    />
  );
};

MoveToJourneyModal.propTypes = {
  title: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  contact: PropTypes.object,
};

MoveToJourneyModal.defaultProps = {
  contact: {},
};

export default MoveToJourneyModal;
